import { useAuth } from "../context/AuthContext";

export function useHasRole(allowed: string | string[]) {
  const { role } = useAuth();
  const arr = Array.isArray(allowed) ? allowed : [allowed];
  return !!role && arr.includes(role);
}

export function useRole() {
  const { role } = useAuth();
  return role;
}

